import router from '@uirouter/angularjs';
import bootstrap from 'angular-ui-bootstrap';
import appStyling from './app.less';
import storage from 'angular-storage';
import translate from 'angular-translate';
import translateUrl from 'angular-translate/dist/angular-translate-loader-url/angular-translate-loader-url.js';
import templateUrl from './app.html';
import ngCookies from 'angular-cookies';
import store from 'angular-storage';
import Dashboard from './dashboard/dashboard.js';
import Common from '@eventix/js-common';
import Login from './login/login.js';
import Register from './register/register.js';
import Loading from './loading/loading.js';
import PasswordReset from './passwordReset/passwordReset.js';
import InvitedUser from './invitedUser/invitedUser.js';
import Sanitize from 'angular-sanitize';
import LoadingBar from 'angular-loading-bar';
import LoadingBarStyling from 'angular-loading-bar/build/loading-bar.css';
import angulartics from 'angulartics';
import NewAuthorization from '@openticket/sdk-auth';

import c3 from 'c3';
import c3styling from 'c3/c3.css';
import daterange from 'bootstrap-daterangepicker';
import daterangeCss from 'bootstrap-daterangepicker/daterangepicker.css';
import bdp from 'eonasdan-bootstrap-datetimepicker';
import bdpStyling from 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

/**
 * @ngdoc overview
 * @name eventix
 * @description
 * <h1>Eventix main module</h1>
 * The root module that initializes the app. It's booted in a three-step process.
 *
 * 1. Check (and refresh) authorization token
 * 2. Fetch models from cache
 * 3. Boot app and kick off the router
 */
angular.module('eventix',[router, bootstrap, storage, Sanitize, LoadingBar, PasswordReset, InvitedUser,
    angulartics, translate, translateUrl, Common, Dashboard, Login, Register, Loading,
    ngCookies, store])
    .factory('AuthSessionInterceptor', function() {
        // We need to send withCredentials to Auth calls
        return {
            request: function(config) {
                function getDomain(urlString) {
                    try {
                        // Create a new URL instance
                        // Note: The URL constructor expects a fully qualified URL with a protocol.
                        const url = new URL(urlString);
                        // hostname property returns the domain name (and subdomain, if any)
                        return url.hostname;
                    } catch (error) {
                        // If the URL is missing a protocol (e.g., "example.com/path"),
                        // prepend a default protocol and try again.
                        try {
                            const url = new URL('http://' + urlString);
                            return url.hostname;
                        } catch (error) {
                            return null;
                        }
                    }
                }

                try {
                    const targetDomain = getDomain(NG_AUTH_API_ROOT); // Replace with your actual domain
                    const configUrl = getDomain(config.url); // config.url could be missing protocol, handle the same
                    if (targetDomain == configUrl) {
                        config.withCredentials = true;
                    }

                    return config;
                }
                catch (error) {
                    return config;
                }
            }
        };
    })
    .config(function($locationProvider, $urlRouterProvider, APIPathInterceptorProvider,
        $stateProvider, $httpProvider, OAuthHeadersProvider, CompanyIdHeadersProvider, $translateProvider,
        IntercomProvider, GoogleTagManagerProvider, LocalesProvider, FBProvider,
        $qProvider, $sceDelegateProvider, $uibTooltipProvider) {

        /* Root state */
        $stateProvider.state('eventix', {
            url: '?editing&new&highlight&as&code&autoselect_dashboard&create_account',
            params: {
                editing: { inherit: false, dynamic: true },
                new: { inherit: false, dynamic: true },
                highlight: { inherit: false, dynamic: true },
                as: undefined,
                code: undefined,
                autoselect_dashboard: undefined,
                create_account: undefined,
            },
            templateUrl: templateUrl,
            abstract: true,
            resolve: /*@ngInject*/{
            },
        });

        $locationProvider.html5Mode(NODE_ENV !== 'testing');
        $urlRouterProvider.otherwise(function($injector, $location) {
            const $state = $injector.get('$state');
            const queryParams = $location.search();
            $state.go('eventix.dashboard.home', queryParams, { location: 'replace' });
        });

        /* $http OAuth interceptor */
        OAuthHeadersProvider.setGrantType('password');
        APIPathInterceptorProvider.setPrefix(DASHBOARD_API_ROOT);
        $httpProvider.interceptors.push('OAuthHeaders');
        $httpProvider.interceptors.push('CompanyIdHeaders');
        $httpProvider.interceptors.push('APIPathInterceptor');
        $httpProvider.interceptors.push('AuthSessionInterceptor');

        $translateProvider.useLoader('languageLoader', {group: 'dashboard'})
            .useStorage('Locales')
            .useInterpolation('LaravelTranslator')
            .registerAvailableLanguageKeys(LocalesProvider.available, LocalesProvider.mapping)
            .uniformLanguageTag('java')
            .determinePreferredLanguage()
            .fallbackLanguage('en_GB');

        IntercomProvider.load();
        GoogleTagManagerProvider.addContainer(DASHBOARD_GTM);
        FBProvider.setAppId(FB_APP_ID_DASHBOARD);
        $qProvider.errorOnUnhandledRejections(NODE_ENV === 'development');


        // Users accepted our terms and conditions all granted
        // function gtag() { window.dataLayer.push(arguments); }
        // gtag("consent", "default", {
        //     ad_user_data: "denied",
        //     ad_personalization: "denied",
        //     ad_storage: "denied",
        //     analytics_storage: "denied",
        //     functionality_storage: "denied",
        //     personalization_storage: "denied",
        //     security_storage: "denied",
        //     wait_for_update: 500,
        // });
        // gtag("consent", "update", {
        //     ad_user_data: "granted",
        //     ad_personalization: "granted",
        //     ad_storage: "granted",
        //     analytics_storage: "granted",
        //     functionality_storage: "granted",
        //     personalization_storage: "granted",
        //     security_storage: "granted",
        // });

        if (NODE_ENV !== 'production') {
            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                'http://localhost:8080/**'
            ]);
        }

        $uibTooltipProvider.options({ appendToBody: true });

    })
    .run(function($rootScope, $window, $http, $location, $state, $translate, $transitions, Locales, LibraryLoader, EventixSocket) {

        let queryParams = $location.search();

        if (queryParams.language && _.find(Locales, {code: queryParams.language}))
            $translate.use(queryParams.language);

        let transitionTo = {
            state: null,
            params: null,
        };

        // Create an SDK authorization instance and bind it to the window
        $window.auth = new NewAuthorization();

        const authConfig = {
            baseUrl: AUTH_API_ROOT,
            clientId: OAUTH_ID,
            clientSecret: OAUTH_SECRET,
            onLogout: () => {
                $state.go('eventix.logout', {}, { reload: true });
            },
        };

        if (NG_AUTH_API_ROOT) {
            authConfig.authBaseUrl = NG_AUTH_API_ROOT;
        }
        if (NG_AUTH_LOGIN_ROOT) {
            authConfig.authLoginBaseUrl = NG_AUTH_LOGIN_ROOT;
        }
        if (NG_DASHBOARD_REDIRECT_URL) {
            // DD-4E5C - Supersedes DD-DASHBOARD-2722
            authConfig.authCodeRedirectUri = NG_DASHBOARD_REDIRECT_URL;
        }
        if (NG_AUTH_CLIENT_ID) {
            authConfig.authCodeClientId = NG_AUTH_CLIENT_ID;
        }
        if (NG_AUTH_CLIENT_SECRET) {
            authConfig.authCodeClientSecret = NG_AUTH_CLIENT_SECRET;
        }

        $window.auth.init(authConfig);

        // if ($window.auth.isLoggedIn) {
        //     console.log('Logged in');
        //     console.log(`Company: ${$window.auth._token.company_id}`);
        // } else {
        //     console.log('Not logged in');
        // }

        $transitions.onStart({}, function(trans) {
            transitionTo.state = trans.to().name;
            transitionTo.params = trans.params();
        });

        // Needed in oauthHeaders, yes EOL
        $rootScope.http = $http;

        $rootScope.branding = {
            logo: DASHBOARD_BRAND_LOGO,
            name: DASHBOARD_BRAND_NAME,
            url: DASHBOARD_BRAND_URL,
        };

        if (APPCUES_ID && (APPCUES_ID).length) {
            LibraryLoader.load('https://fast.appcues.com/' + APPCUES_ID);
        }

    });

// Bootstrap the app ONLY after we have a token
if(NODE_ENV !== 'testing') {
    angular.element(document).ready(function() {
        var el = document.getElementById('ng-app');
        angular.bootstrap(el, ['eventix']);
        angular.element(el).attr('ng-app','eventix');
    });
}
